export default "__VITE_ASSET__1494640d__"